import { put, getContext } from 'redux-saga/effects'
import importer from 'common/importer'
const { getPhoneTypes } = importer('GraphQL/Queries')
const PublicContentActions = importer('Stores/PublicContent/Actions')
import i18next from 'i18next';
export default function * main () {
  try {
    const isSpanish = i18next.language === 'es-MX'
    yield put(PublicContentActions.getPhoneTypesLoading())
    const apolloClient = yield getContext('client')
    const query = getPhoneTypes
    const {data, error} = yield apolloClient.query({query, variables: {isSpanish : isSpanish } })
    if (error) { throw error }
    const phoneTypeList=[]
    data.pdt_phone_type && data.pdt_phone_type.length && data.pdt_phone_type.map((item, index) => {
      phoneTypeList.push({
        label: item.description,
        value: item.code
      })
    })
    yield put(PublicContentActions.getPhoneTypesSuccess(phoneTypeList))
  } catch (error) {
    yield put(PublicContentActions.getPhoneTypesFailure(error))
  }
}
